export enum MarketDataTabType {
  DetailedQuote = 'detailedQuote',
  HistoricalQuotes = 'historicalQuotes',
  CompanyFinancials = 'companyFinancials',
  SecFilling = 'secFilling',
}
